import Button from "components/form/Button";
import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { useNavigate, useParams } from "react-router-dom";
import {
  decode,
  encode,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

interface InvoiceFailProps {
  failedReason: string | null;
  handleBackToStart: any;
}

const InvoiceFail = (props: InvoiceFailProps) => {
  const { failedReason, handleBackToStart } = props;
  const navigate = useNavigate();
  const { id: actionId } = useParams();
  const testAttrs = useTestAttrsFactory();
  let slug = decode(actionId || "")?.split("_");
  let cluster_id = encode(slug[1], "ci_");
  return (
    <div
      className="h-full flex items-center justify-center lg:pb-0 pb-10"
      {...testAttrs("failed", "Invoice payment failed")}
    >
      <div className="w-full max-w-[630px] mx-auto px-5 flex flex-col justify-center items-center gap-6">
        <div className="flex flex-col justify-center items-center gap-10 w-full">
          <FailedAgreementIcon aria-hidden="true" />
          <div className="w-full text-center text-2xl text-txtPrimary font-medium">
            Payment failed
          </div>
          <div className="w-full text-center bg-bgThird lg:py-5 py-4 lg:px-2 px-3 lg:text-xl text-base text-txtParagraph  break-words">
            {customerFacingPaymentError(failedReason) || "Payment Failed"}
          </div>
          <div className="w-full text-center text-txtParagraph lg:text-xl text-base">
            Sorry! Your payment method was declined.
          </div>
          <div>
            <Button
              text={"Update payment method"}
              className="text-base px-11"
              {...testAttrs("update-payment-method", "Update payment method")}
              onClick={() => handleBackToStart()}
            />
          </div>
        </div>
        <div className="w-full lg:text-base text-sm text-center text-btnPrimaryActive hover:!text-btnPrimaryHover ">
          <div
            className="cursor-pointer"
            role="button"
            tabIndex={0}
            {...testAttrs("back-to-dashboard", "Back to dashboard")}
            onClick={() => navigate(`/${cluster_id}/dashboard`)}
          >
            Back to dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFail;
